import { render, staticRenderFns } from "./MainOrder.vue?vue&type=template&id=57407136&scoped=true"
import script from "./MainOrder.vue?vue&type=script&lang=ts"
export * from "./MainOrder.vue?vue&type=script&lang=ts"
import style0 from "./MainOrder.vue?vue&type=style&index=0&id=57407136&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../nhaphangtocdo/client/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57407136",
  null
  
)

export default component.exports